import { useEffect, useState } from "react";

//App
import { DrawerProps } from "../../../../types";
import useDrawerStyles from "./styles";
import useScreenSize from "../../../hooks/useScreenSize";
import { MIN_LARGE_SCREEN_SIZE } from "../../../../utility/constants";
import { CSSObject } from "styled-components";

const Drawer: React.FC<DrawerProps> = ({
  show,
  children,
  fullWidth = false,
}) => {
  const [isOpen, setIsOpen] = useState(show);

  const drawerStyles = useDrawerStyles();
  const windowWidth = useScreenSize();
  const isSmallMediumScreen = windowWidth < MIN_LARGE_SCREEN_SIZE;

  if (isSmallMediumScreen) fullWidth = true;

  useEffect(() => {
    setIsOpen(show);
  }, [show]);

  const responsiveDrawer: CSSObject = {
    width: fullWidth ? "100%" : "35%",
    maxWidth: fullWidth ? "100%" : "80%",
  };

  return (
    <div
      style={
        isOpen ? drawerStyles.drawerContainerOpen : drawerStyles.drawerContainer
      }
    >
      <div style={{ ...drawerStyles.drawer, ...responsiveDrawer }}>
        <div style={drawerStyles.drawerContent}>{children}</div>
      </div>
    </div>
  );
};

export default Drawer;
